module.exports = __webpack_public_path__ + "img/service.15c09d66.png";